<template>
  <div class="pages service">
    <div class="container">
      <p>
        <strong
          >Update date: 2025-01-12<br />
          Effective date：2025-01-12</strong
        >
      </p>
      <p>
        <strong>1.Introduction</strong><br />
        Welcome to “DreamPaint,” the software and related services provided by
        Mojing Technology Co., Ltd. This refers to the client application named
        “DreamPaint,” which the company legally owns and operates, offering you
        products and services, including but not limited to drawing creation,
        tutorials, material recommendations, and other features. The “DreamPaint
        User Agreement” (hereinafter referred to as “this Agreement”) is the
        agreement between you and the company regarding your registration,
        login, and use of the “DreamPaint” software and related services.
      </p>
      <p>
        To better serve you, please make sure to carefully read and fully
        understand this Agreement before you start using the “DreamPaint”
        software and related services, especially the clauses regarding
        exemption or limitation of liability, rights licensing and information
        usage, agreements for activating and using special individual services,
        applicable laws, and dispute resolution. Important contents, such as the
        exemption or limitation of liability clauses, will be highlighted in
        bold for your attention, and you should pay special attention to them.
      </p>
      <p>
        You must meet the legal age requirements established by your state,
        province, region, country, or jurisdiction in order to obtain permission
        to use the software and this Agreement. If you are not of legal age, you
        must have obtained permission from your parent or guardian to use this
        service, and you should encourage your parent or guardian to agree to
        these terms on your behalf.
      </p>
      <p>
        If you access or use this service on behalf of a business or entity, you
        must warrant that you have the authority to bind that entity to these
        terms and that you agree to these terms on behalf of that entity.
      </p>
      <p>
        <strong
          >Once you use the “DreamPaint” software and related services, it is
          considered that you have fully understood this Agreement and agree to
          accept the terms of this Agreement as a party to it, as well as to be
          bound by other agreements and rules related to the “DreamPaint”
          software and related services (including but not limited to the
          “Privacy Policy”).</strong
        >
      </p>
      <p>
        <strong>2.DreamPaint account</strong><br />
        2.1The “DreamPaint” software and related services provide you with a
        registration channel, allowing you to log in using services provided by
        third parties (such as Apple, Facebook, Google, etc.) to create a new
        account or log into an existing account.
      </p>
      <p>
        2.2 When registering and using your account, you must comply with laws
        and regulations and ensure the authenticity of the information provided.
        You must not include any illegal, non-compliant, or infringing
        information in your registration materials. Your account name, profile
        picture, introduction, and other personal information must not contain
        illegal or inappropriate content (including but not limited to
        impersonating others’ names, titles, trademarks, profile pictures, etc.,
        in a way that could cause confusion). You must not maliciously register
        a “DreamPaint” account (including but not limited to frequent
        registration, bulk registration of accounts, etc.). The company reserves
        the right to review the registration information you submit.
      </p>
      <p>
        2.3 Your account is for your personal use only. Without the company’s
        written consent, you are prohibited from gifting, borrowing, renting,
        transferring, selling, or otherwise allowing others to use the account
        in any form. If the company discovers or has reasonable grounds to
        believe that the user is not the original registrant of the account, it
        reserves the right to suspend or terminate services to that registered
        account and cancel the account without notifying you.
      </p>
      <p>
        2.4 You are responsible for maintaining the security and confidentiality
        of your personal account and password, and you bear all legal
        responsibilities for any activities conducted under your registered
        account name. This includes, but is not limited to, any data
        modifications, information postings, payments, and other actions taken
        on the “DreamPaint” software and related services that may result in
        legal liability. You should prioritize the confidentiality of your
        account and password and must not disclose them to others under any
        circumstances. If you discover that someone else is using your account
        without permission or if you encounter any other security issues, you
        should immediately notify the company. You understand and agree that
        until you file a complaint or explicitly inform the official DreamPaint
        account about the unauthorized use of your account or data leakage, and
        provide relevant proof, DreamPaint has reason to believe that any
        actions taken with the account are carried out by you.
      </p>
      <p>
        2.5 You understand and agree that in order to fully utilize the account
        resources, if you do not log in for the first time promptly after
        registration or if you do not log into your account for more than two
        consecutive months, the company has the right to reclaim your account.
      </p>
      <p>
        <strong>3.Privacy protection</strong><br />
        3.1 You understand and agree that, in order to provide better services
        to users, DreamPaint will collect users’ personal information when users
        voluntarily choose services or provide information, and will integrate
        this information. When users use the services, the server will
        automatically record some information, including but not limited to URL,
        IP address, browser type, language used, access date and time, etc. To
        facilitate user login or service usage, DreamPaint will use cookies and
        other technologies as needed and will send the collected information to
        the corresponding server. Users can choose to accept or refuse cookies.
        If users choose to refuse cookies, they may not be able to log in or use
        services or features that rely on cookies. The information collected by
        DreamPaint will become part of the regular business records and may be
        transferred to DreamPaint’s successor company or designated party due to
        reasons such as transfer, merger, acquisition, or reorganization.
        DreamPaint will use the collected information in good faith and take
        measures to ensure the security of the information.
      </p>
      <p>
        3.2 DreamPaint may collaborate with third parties to provide relevant
        services to users. In this case, if the third party agrees to assume the
        same responsibilities for protecting user privacy as DreamPaint, user
        information may be provided to that third party. The specific privacy
        policy terms can be found in the “Privacy Policy.”
      </p>
      <p>
        <strong>4.Prohibited conduct</strong><br />
        4.1 The creation, copying, publishing, dissemination, and other
        activities that are prohibited by laws and regulations, violate legal
        statutes, public order, or moral standards, and infringe on the
        intellectual property rights or other legitimate rights of other users
        or third parties, include the following contents:<br />
        a) Infringing on any rights belonging to others, including intellectual
        property rights, portrait rights, or privacy rights.<br />
        b) Engaging in unfair discrimination, defamation, harming the reputation
        of others, or violating trust in relation to others.<br />
        c) Discrimination, defamation, inappropriate language, bullying,
        threats, harassment, or any other conduct that causes psychological harm
        to another party, damages that party’s reputation, or violates that
        party’s trust.<br />
        d) Advertising or promotional activities, political activities
        (including campaign activities), religious activities (including
        missionary activities), solicitation, and recruitment activities related
        to multi-level marketing.<br />
        e) Disclosing your own or third-party personal information, or
        unlawfully obtaining third-party personal information through improper
        means.<br />
        f) Engaging in criminal behavior or encouraging criminal behavior.<br />
        g) Engaging directly or indirectly in profit-seeking activities for
        anti-social forces, or activities associated with anti-social forces.<br />
        h) Engaging in actions that cause harm or damage to others, or that may
        delay or obstruct financial obligations.<br />
        i) Other activities deemed inappropriate by DreamPaint.
      </p>
      <p>
        4.2 Logging into or using DreamPaint or its services through third-party
        compatible software, systems, or plugins not developed, authorized, or
        recognized by Hangzhou Mojing Technology Co., Ltd.
      </p>
      <p>
        4.3 Deleting any copyright information from DreamPaint software and
        other copies.
      </p>
      <p>
        4.4 Without the permission of Hangzhou Mojing Technology Co., Ltd.,
        performing reverse engineering, disassembling, decompiling the
        DreamPaint software, or obtaining source code through other illegal
        means.
      </p>
      <p>
        4.5 Engaging without consent from Hangzhou Mojing Technology Co., Ltd.
        in behaviors related to the information of DreamPaint software,
        including but not limited to: using, renting, lending, copying,
        modifying, linking, reprinting, compiling, publishing, or establishing
        mirror sites; inappropriately developing derivative products, works,
        services, plugins, add-ons, or compatible technologies related to
        DreamPaint.
      </p>
      <p>
        4.6 Posting content that damages DreamPaint software, publishing links
        that contain viruses or malware, using admin passwords or impersonating
        administrators, repeatedly posting spam, using alternative accounts or
        external organizations to manipulate DreamPaint data.
      </p>
      <p>
        4.7 Other actions that violate laws and regulations, policies, public
        order and morals, social ethics, or disrupt the normal operation of
        DreamPaint and infringe on the legitimate rights and interests of other
        users or third parties.
      </p>
      <p>
        4.8 You shall bear legal responsibility for your actions while using
        DreamPaint services. The form of your legal liability includes but is
        not limited to: compensating the injured parties; and, if DreamPaint
        first incurs administrative penalties or liability for damages due to
        your actions, you shall compensate DreamPaint for an equivalent amount.
        If you violate the above provisions, DreamPaint has the right to
        independently determine to immediately suspend or terminate some or all
        services to you.
      </p>
      <p>
        4.9 You understand and commit that without DreamPaint’s consent, you
        cannot use DreamPaint for sales or other commercial purposes. If you
        need to use DreamPaint or its services for commercial purposes, you must
        inform DreamPaint in writing and obtain explicit authorization from the
        company.
      </p>
      <p>
        4.10 You understand that DreamPaint may display various commercial
        advertisements or other commercial information while providing services.
      </p>
      <p>
        <strong>5.Ownership and Intellectual Property Rights</strong><br />
        5.1 DreamPaint will protect intellectual property rights as one of its
        fundamental operational principles.
      </p>
      <p>
        5.2 You understand and agree that when using DreamPaint software and
        related services, any text, images, videos, etc., that you upload or
        publish must be original to you or legally authorized. The intellectual
        property rights to any content you create, upload, or publish through
        DreamPaint belong to you or the original copyright holder.
      </p>
      <p>
        5.3 You must ensure that you have the necessary authorizations or
        permissions to create, copy, publish, and disseminate works on
        DreamPaint. For the avoidance of doubt, “works” as referred to in this
        section includes any forms of works, products, codes, comments, posts,
        or other content published by users on DreamPaint.
      </p>
      <p>
        5.4 Except for works created and published by users themselves, all
        content on DreamPaint, including but not limited to text, audio, images,
        videos, graphs, and the arrangement of web page screens, is legally
        owned by DreamPaint or other rights holders in terms of their
        intellectual property rights, including but not limited to copyright,
        trademark rights, and patent rights. Unless otherwise agreed in this
        agreement, you may not modify, copy, disseminate, alter, distribute, or
        publish the aforementioned content without the consent of DreamPaint or
        other rights holders. If you violate this, you agree to bear all losses
        caused to DreamPaint or other rights holders as a result.
      </p>
      <p>
        <strong>6.Breach handling</strong><br />
        6.1 In the event of your violation of this agreement or other service
        terms, the company has the right to independently judge the situation
        and may take measures such as issuing prior warnings, refusing to
        publish, restricting some or all functions of your account, or even
        permanently closing your account. The company has the right to announce
        the results of such actions and determine whether to restore the use of
        the relevant account based on the actual circumstances. Any behavior
        suspected of violating laws and regulations, or suspected criminal
        activity, will be recorded and reported to the relevant authorities,
        cooperating with investigations by these authorities.
      </p>
      <p>
        6.2 If your violation of this agreement or other service terms results
        in complaints or lawsuits from third parties, you shall handle these
        matters yourself and bear all legal responsibilities that may arise
        therefrom. If your illegal or breach of contract actions cause the
        company or its affiliated companies or controlled companies to
        compensate any third party or to be penalized by government agencies,
        you shall also fully compensate the company and its affiliated companies
        or controlled companies for all losses incurred as a result.
      </p>
      <p>
        <strong>7.Interruption, suspension and termination of services</strong
        ><br />
        7.1 You understand and agree that the DreamPaint software and related
        services provided by the company are offered as-is, based on existing
        technology and conditions. The company will make every effort to provide
        you with services and ensure the continuity and security of those
        services. You understand that the company cannot foresee and prevent all
        technological and other risks at all times, including but not limited to
        force majeure, viruses, Trojans, hacking attacks, system instability,
        and defects in third-party services, which may cause service
        interruptions, data loss, and other losses and risks.
      </p>
      <p>
        7.2 You understand and agree that the company has the right to modify,
        suspend, interrupt, or terminate the DreamPaint software and related
        services as necessary for the overall operation of its services, after
        providing appropriate notice, without any obligation to you or any
        liability for compensation.
      </p>
      <p>
        <strong>8.Disclaimer</strong><br />
        8.1 You understand and agree that the DreamPaint software and related
        services may be influenced or interrupted by various factors, and the
        company does not guarantee (including but not limited to):<br />
        a) That the software will fully meet the user’s requirements;<br />
        b) That any errors in the software will be corrected.
      </p>
      <p>
        8.2 With regard to information related to suspected borrowing, financial
        management, or other property-related online information, account
        passwords, advertisements, or promotions, please exercise caution and
        make your own judgments. For the losses you incur due to the
        aforementioned reasons, including but not limited to property, profits,
        business reputation, and data losses, the company shall not be liable
        for any direct, indirect, incidental, special, consequential, or
        punitive damages.
      </p>
      <p>
        <strong
          >8.3You understand and agree that during your use of the DreamPaint
          software and related services, you may encounter factors such as force
          majeure (force majeure refers to unforeseen, insurmountable, and
          unavoidable objective events), including but not limited to government
          actions, regulatory policies, natural disasters, network issues,
          hacking attacks, war, or any other similar events. In the event of a
          force majeure situation, the company will make every effort to
          promptly address and rectify the issue, but you agree that the company
          shall not be liable for any legal responsibility for any suspension,
          interruption, or termination of services or any losses incurred due to
          force majeure.</strong
        >
      </p>
      <p>
        8.4 The company has the right to process illegal and non-compliant
        content as stipulated in this agreement; however, this right does not
        constitute an obligation or commitment on the part of the company, and
        the company cannot guarantee the timely detection of illegal activities
        or take appropriate action.
      </p>
      <p>
        8.5 You understand and agree that with regard to the DreamPaint software
        and related services, the company does not provide any kind of express
        or implied warranties or conditions, including but not limited to
        merchantability and fitness for a particular purpose. You must assume
        all risks associated with your use of the DreamPaint software and
        related services.
      </p>
      <p>
        8.6 You understand and agree that this agreement aims to ensure
        compliance with national laws and regulations, uphold public order and
        morality, and protect the legitimate rights and interests of others. The
        company will make its best efforts to make judgments in accordance with
        relevant laws and regulations within its ability; however, it does not
        guarantee that its judgments will fully align with those of judicial or
        administrative authorities. You have understood and agreed to assume the
        consequences arising from this.
      </p>
      <p>
        <strong>9.Changes to these Terms of Service</strong><br />
        9.1 We will make commercially reasonable efforts to notify all users of
        any significant changes to these terms, for example, through
        notifications on the platform. However, you should regularly review the
        terms to check for such changes. We will also update the “Last Updated”
        date at the top of these terms to reflect the effective date of the
        changes. If you continue to access or use the service after the new
        terms take effect, it means you accept the new terms. If you do not
        agree with the new terms, you must cease your access to or use of the
        service.
      </p>
      <p>
        9.2 The signing location of this agreement is Binjiang District,
        Hangzhou, People’s Republic of China. If any disputes arise between you
        and us, both parties shall try to resolve the issues through friendly
        negotiation. If negotiation fails, you agree to submit the dispute to
        the competent People’s Court in Binjiang District, Hangzhou, for
        litigation.
      </p>
      <p>
        <strong>10.Governing Law and Dispute Resolution</strong><br />
        If the laws of your country stipulate that the agreement must be
        governed by the local laws of the consumer’s country, then this
        agreement will be governed by the applicable laws and regulations within
        your country.
      </p>
      <p>
        10.1 Additional Terms for U.S. Users<br />
        If you reside in the United States, this agreement shall be governed by
        U.S. federal law or the laws of your state of residence. For any
        disputes arising from or related to this agreement, if we are unable to
        resolve the issue amicably, it shall be resolved through binding
        arbitration administered by the American Arbitration Association.
      </p>
      <p>
        10.2 Additional Terms for European Users<br />
        If you are a resident of the European Economic Area, this agreement will
        be governed by local laws. If you are a resident of any other country,
        unless local laws explicitly prohibit it, this agreement will be
        governed by the laws of the People’s Republic of China, and any disputes
        between you and us regarding this agreement will be under the
        jurisdiction of the competent People’s Court in Binjiang District,
        Hangzhou. Unless explicitly stated in this document and permitted by
        applicable laws, this agreement shall not impair any statutory rights
        that cannot be excluded for a party engaged in a consumer transaction.
      </p>
      <p>
        <strong>11Other</strong><br />
        11.1 If any provision of this agreement conflicts with the law, the law
        shall prevail, and the relevant content will be modified or
        reinterpreted in accordance with the legal provisions, while the legal
        validity of the other parts of this agreement remains unchanged.
      </p>
      <p>
        11.2 This agreement shall take effect from the date of publication and
        constitutes the consensus between you and DreamPaint.
      </p>
      <p>
        11.3 DreamPaint’s failure to exercise, delayed exercise, or insufficient
        exercise of any rights under this agreement or under the law shall not
        be deemed a waiver of that right and does not affect DreamPaint’s
        ability to exercise that right in the future.
      </p>
      <p>
        11.4 If you have any questions or concerns regarding this agreement, or
        if you wish to exercise your rights, please contact us via email at
        dev@huanci.ltd.
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: "hsjproService",
  components: {},
  created() {},
  computed: {},
  methods: {
    test() {
      if (true) {
      }
    },
  },
};
</script>

<style lang="scss">
.service {
  .container {
    font-size: 14px;
    h1 {
      font-size: 24px;
    }
    .top__desc {
      font-size: 14px;
      text-indent: 2em;
      line-height: 2;
    }
    h6.subtitle {
      font-size: 14px;
      font-weight: normal;
      margin-top: 10px;
      margin-bottom: 10px;
    }
    .third-url-list {
      > a {
        display: block;
      }
    }
    li {
      > h2 {
        display: inline;
        font-size: 14px;
        font-weight: bold;
        + ol {
          margin-top: 15px;
        }
      }
      p {
        margin-top: 1em;
        margin-bottom: 0;
      }
    }
  }
  p {
    margin-top: 1em;
    margin-bottom: 0;
    line-height: 2;
  }
  a {
    // display: block;
    word-break: break-all;
    color: #1989fa;
    text-decoration: none;
  }
  .sdk-table {
    color: #646466;
    font-size: 14px;
    border-spacing: 0;
    border: 1px solid #ebeef5;
    table-layout: fixed;
    width: 100%;
    line-height: normal;
    text-indent: initial;
    text-align: center;
    tr {
      > th {
        padding: 8px 10px;
        border-bottom: 1px solid #d9d9db;
        &:first-child,
        &:last-child {
          width: 80px;
        }
      }
    }
    th,
    td {
      box-sizing: border-box;
      font-weight: normal;
      border-bottom: 1px solid #ebeef5;
      border-right: 1px solid #ebeef5;
    }
    td {
      padding: 10px 8px;
      vertical-align: middle;
      text-align: center;
    }
  }
}
</style>
